import { render, staticRenderFns } from "./base-text-field.vue?vue&type=template&id=7720c82c"
import script from "./base-text-field.ts?vue&type=script&lang=ts&external"
export * from "./base-text-field.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports